var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg"},[_c('Timer',{attrs:{"data":_vm.data},on:{"next":_vm.onClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }